(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aa-announcement-bar"] && !Shopify.designMode) return;
  try {
    
function aaWinterBarInit() {
  var designMode = !!(window.Shopify && window.Shopify.designMode);

  document.querySelectorAll('[data-aa-wbar]').forEach(function (bar) {
    if (bar.dataset.aaInit) return;
    bar.dataset.aaInit = 'true';

    // Close button: remembered for the browser session (ignored in the theme editor so it stays editable).
    var key = bar.dataset.dismissKey;
    if (key && !designMode) {
      try {
        if (sessionStorage.getItem(key) === '1') {
          bar.hidden = true;
          return;
        }
      } catch (e) {}
    }
    var closeBtn = bar.querySelector('[data-aa-wbar-close]');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        bar.hidden = true;
        if (key && !designMode) {
          try { sessionStorage.setItem(key, '1'); } catch (e) {}
        }
      });
    }

    // Countdown: every copy (static + ticker clone) is updated together.
    var timers = bar.querySelectorAll('[data-aa-wbar-countdown]');
    var end = new Date(bar.dataset.end).getTime();
    if (isNaN(end)) return;
    var hideBar = bar.dataset.hideOnExpire === 'true';
    var interval;

    function pad(n) {
      return String(n).padStart(2, '0');
    }
    function set(sel, value) {
      bar.querySelectorAll(sel).forEach(function (el) { el.textContent = value; });
    }
    function tick() {
      var diff = end - Date.now();
      if (diff <= 0) {
        if (hideBar && !designMode) bar.hidden = true;
        bar.querySelectorAll('[data-aa-wbar-countdown], [data-aa-wbar-countdown-sep]').forEach(function (t) { t.hidden = true; });
        if (interval) clearInterval(interval);
        return;
      }
      if (!timers.length) return;
      set('[data-d]', pad(Math.floor(diff / 86400000)));
      set('[data-h]', pad(Math.floor((diff % 86400000) / 3600000)));
      set('[data-m]', pad(Math.floor((diff % 3600000) / 60000)));
      set('[data-s]', pad(Math.floor((diff % 60000) / 1000)));
    }

    tick();
    interval = setInterval(tick, 1000);
  });
}

aaWinterBarInit();
document.addEventListener('shopify:section:load', aaWinterBarInit);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aa-black-friday-announcement-bar"] && !Shopify.designMode) return;
  try {
    
function aaBfBarInit() {
  var designMode = !!(window.Shopify && window.Shopify.designMode);

  document.querySelectorAll('[data-aa-bfbar]').forEach(function (bar) {
    if (bar.dataset.aaInit) return;
    bar.dataset.aaInit = 'true';

    // Close button: remembered for the browser session (ignored in the theme editor so it stays editable).
    var key = bar.dataset.dismissKey;
    if (key && !designMode) {
      try {
        if (sessionStorage.getItem(key) === '1') {
          bar.hidden = true;
          return;
        }
      } catch (e) {}
    }
    var closeBtn = bar.querySelector('[data-aa-bfbar-close]');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        bar.hidden = true;
        if (key && !designMode) {
          try { sessionStorage.setItem(key, '1'); } catch (e) {}
        }
      });
    }

    // Countdown: every copy (static + ticker clone) is updated together.
    var timers = bar.querySelectorAll('[data-aa-bfbar-countdown]');
    var end = new Date(bar.dataset.end).getTime();
    if (isNaN(end)) return;
    var hideBar = bar.dataset.hideOnExpire === 'true';
    var interval;

    function pad(n) {
      return String(n).padStart(2, '0');
    }
    function set(sel, value) {
      bar.querySelectorAll(sel).forEach(function (el) { el.textContent = value; });
    }
    function tick() {
      var diff = end - Date.now();
      if (diff <= 0) {
        if (hideBar && !designMode) bar.hidden = true;
        bar.querySelectorAll('[data-aa-bfbar-countdown], [data-aa-bfbar-countdown-sep]').forEach(function (t) { t.hidden = true; });
        if (interval) clearInterval(interval);
        return;
      }
      if (!timers.length) return;
      set('[data-d]', pad(Math.floor(diff / 86400000)));
      set('[data-h]', pad(Math.floor((diff % 86400000) / 3600000)));
      set('[data-m]', pad(Math.floor((diff % 3600000) / 60000)));
      set('[data-s]', pad(Math.floor((diff % 60000) / 1000)));
    }

    tick();
    interval = setInterval(tick, 1000);
  });
}

aaBfBarInit();
document.addEventListener('shopify:section:load', aaBfBarInit);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aa-black-friday-hero"] && !Shopify.designMode) return;
  try {
    
function aaBfHeroInitCountdowns() {
  document.querySelectorAll('[data-countdown]').forEach(function (el) {
    if (el.dataset.aaInit) return;
    el.dataset.aaInit = 'true';

    var end = new Date(el.dataset.end).getTime();
    if (isNaN(end)) return;

    var daysEl = el.querySelector('[data-days]');
    var hoursEl = el.querySelector('[data-hours]');
    var minutesEl = el.querySelector('[data-minutes]');
    var secondsEl = el.querySelector('[data-seconds]');
    var wrap = el.closest('[data-countdown-wrap]');
    var expiredEl = wrap ? wrap.querySelector('[data-expired-message]') : null;
    var sectionEl = el.closest('.aa-bf-hero');
    var endsEl = sectionEl ? sectionEl.querySelector('[data-aa-ends]') : null;
    var hideSection = el.dataset.hideOnExpire === 'true';
    var timer;

    function pad(n) {
      return String(n).padStart(2, '0');
    }

    function tick() {
      var diff = end - Date.now();
      if (diff <= 0) {
        el.hidden = true;
        if (expiredEl) expiredEl.hidden = false;
        if (endsEl) endsEl.hidden = true;
        if (hideSection && sectionEl) sectionEl.hidden = true;
        if (timer) clearInterval(timer);
        return;
      }
      if (daysEl) daysEl.textContent = pad(Math.floor(diff / 86400000));
      if (hoursEl) hoursEl.textContent = pad(Math.floor((diff % 86400000) / 3600000));
      if (minutesEl) minutesEl.textContent = pad(Math.floor((diff % 3600000) / 60000));
      if (secondsEl) secondsEl.textContent = pad(Math.floor((diff % 60000) / 1000));
    }

    tick();
    timer = setInterval(tick, 1000);
  });
}

function aaBfHeroInitCopyButtons() {
  document.querySelectorAll('.aa-bf-hero__code-copy').forEach(function (btn) {
    if (btn.dataset.aaInit) return;
    btn.dataset.aaInit = 'true';

    btn.addEventListener('click', function () {
      var text = btn.dataset.copy;
      if (!text || !navigator.clipboard) return;
      navigator.clipboard.writeText(text).then(function () {
        var original = btn.textContent;
        btn.textContent = btn.dataset.copiedLabel || 'Copied!';
        setTimeout(function () {
          btn.textContent = original;
        }, 2000);
      });
    });
  });
}

// Desktop keeps the highlight on one line; if a long translation doesn't fit the content
// width, scale its text down until it does (mobile wraps instead, so it's left alone).
function aaBfHeroFitHighlights() {
  var desktop = window.matchMedia('(min-width: 750px)').matches;
  document.querySelectorAll('[data-aa-highlight]').forEach(function (el) {
    el.style.fontSize = '';
    if (!desktop) return;
    var available = el.parentElement.clientWidth - 8;
    var needed = el.scrollWidth;
    if (needed > available && available > 0) {
      var size = parseFloat(getComputedStyle(el).fontSize);
      el.style.fontSize = Math.floor(size * available / needed) + 'px';
    }
  });
}

var aaBfHeroResizeTimer;
window.addEventListener('resize', function () {
  clearTimeout(aaBfHeroResizeTimer);
  aaBfHeroResizeTimer = setTimeout(aaBfHeroFitHighlights, 150);
});
if (document.fonts && document.fonts.ready) document.fonts.ready.then(aaBfHeroFitHighlights);

aaBfHeroInitCountdowns();
aaBfHeroInitCopyButtons();
aaBfHeroFitHighlights();
document.addEventListener('shopify:section:load', function () {
  aaBfHeroInitCountdowns();
  aaBfHeroInitCopyButtons();
  aaBfHeroFitHighlights();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aa-sale-hero"] && !Shopify.designMode) return;
  try {
    
function aaSaleHeroInitCountdowns() {
  document.querySelectorAll('[data-countdown]').forEach(function (el) {
    if (el.dataset.aaInit) return;
    el.dataset.aaInit = 'true';

    var end = new Date(el.dataset.end).getTime();
    if (isNaN(end)) return;

    var daysEl = el.querySelector('[data-days]');
    var hoursEl = el.querySelector('[data-hours]');
    var minutesEl = el.querySelector('[data-minutes]');
    var secondsEl = el.querySelector('[data-seconds]');
    var wrap = el.closest('[data-countdown-wrap]');
    var expiredEl = wrap ? wrap.querySelector('[data-expired-message]') : null;
    var sectionEl = el.closest('.aa-sale-hero');
    var endsEl = sectionEl ? sectionEl.querySelector('[data-aa-ends]') : null;
    var hideSection = el.dataset.hideOnExpire === 'true';
    var timer;

    function pad(n) {
      return String(n).padStart(2, '0');
    }

    function tick() {
      var diff = end - Date.now();
      if (diff <= 0) {
        el.hidden = true;
        if (expiredEl) expiredEl.hidden = false;
        if (endsEl) endsEl.hidden = true;
        if (hideSection && sectionEl) sectionEl.hidden = true;
        if (timer) clearInterval(timer);
        return;
      }
      if (daysEl) daysEl.textContent = pad(Math.floor(diff / 86400000));
      if (hoursEl) hoursEl.textContent = pad(Math.floor((diff % 86400000) / 3600000));
      if (minutesEl) minutesEl.textContent = pad(Math.floor((diff % 3600000) / 60000));
      if (secondsEl) secondsEl.textContent = pad(Math.floor((diff % 60000) / 1000));
    }

    tick();
    timer = setInterval(tick, 1000);
  });
}

function aaSaleHeroInitCopyButtons() {
  document.querySelectorAll('.aa-sale-hero__code-copy').forEach(function (btn) {
    if (btn.dataset.aaInit) return;
    btn.dataset.aaInit = 'true';

    btn.addEventListener('click', function () {
      var text = btn.dataset.copy;
      if (!text || !navigator.clipboard) return;
      navigator.clipboard.writeText(text).then(function () {
        var original = btn.textContent;
        btn.textContent = btn.dataset.copiedLabel || 'Copied!';
        setTimeout(function () {
          btn.textContent = original;
        }, 2000);
      });
    });
  });
}

// Desktop keeps the highlight on one line; if a long translation doesn't fit the content
// width, scale its text down until it does (mobile wraps instead, so it's left alone).
function aaSaleHeroFitHighlights() {
  var desktop = window.matchMedia('(min-width: 750px)').matches;
  document.querySelectorAll('[data-aa-highlight]').forEach(function (el) {
    el.style.fontSize = '';
    if (!desktop) return;
    var available = el.parentElement.clientWidth - 8;
    var needed = el.scrollWidth;
    if (needed > available && available > 0) {
      var size = parseFloat(getComputedStyle(el).fontSize);
      el.style.fontSize = Math.floor(size * available / needed) + 'px';
    }
  });
}

var aaSaleHeroResizeTimer;
window.addEventListener('resize', function () {
  clearTimeout(aaSaleHeroResizeTimer);
  aaSaleHeroResizeTimer = setTimeout(aaSaleHeroFitHighlights, 150);
});
if (document.fonts && document.fonts.ready) document.fonts.ready.then(aaSaleHeroFitHighlights);

aaSaleHeroInitCountdowns();
aaSaleHeroInitCopyButtons();
aaSaleHeroFitHighlights();
document.addEventListener('shopify:section:load', function () {
  aaSaleHeroInitCountdowns();
  aaSaleHeroInitCopyButtons();
  aaSaleHeroFitHighlights();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-advanced"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initNewsletterAdv(root) {
    if (!root || root.dataset.naInit === 'true') return;
    root.dataset.naInit = 'true';

    var form = root.querySelector('[data-newsletter-form-wrapper] form');
    if (!form) return;

    var field = root.querySelector('[data-newsletter-field]');
    var input = root.querySelector('[data-newsletter-input]');
    var submitBtn = root.querySelector('[data-newsletter-submit]');
    var inlineError = root.querySelector('[data-newsletter-inline-error]');
    var consent = root.querySelector('[data-newsletter-consent]');
    var wrapper = root.querySelector('[data-newsletter-form-wrapper]');

    var emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    function showInlineError(msg) {
      if (!inlineError) return;
      inlineError.textContent = msg;
      inlineError.hidden = false;
      if (field) field.classList.add('is-invalid');
    }
    function clearInlineError() {
      if (!inlineError) return;
      inlineError.hidden = true;
      inlineError.textContent = '';
      if (field) field.classList.remove('is-invalid');
    }
    function setLoading(isLoading) {
      if (!submitBtn) return;
      submitBtn.disabled = isLoading;
      submitBtn.setAttribute('aria-busy', isLoading ? 'true' : 'false');
    }

    if (input) {
      input.addEventListener('input', clearInlineError);
    }

    function bindCopyButtons(scope) {
      var btn = scope.querySelector('[data-newsletter-copy]');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var code = btn.getAttribute('data-code') || '';
        var done = function () {
          btn.dataset.copied = 'true';
          var original = btn.textContent;
          btn.textContent = 'Gekopieerd!';
          setTimeout(function () {
            btn.textContent = original;
            btn.dataset.copied = 'false';
          }, 2000);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(done).catch(function () { fallbackCopy(code, done); });
        } else {
          fallbackCopy(code, done);
        }
      });
    }
    function fallbackCopy(text, done) {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      try { document.execCommand('copy'); } catch (e) {}
      document.body.removeChild(ta);
      done();
    }
    bindCopyButtons(root);

    form.addEventListener('submit', function (e) {
      clearInlineError();

      var emailValue = input ? input.value.trim() : '';
      if (!emailValue || !emailRe.test(emailValue)) {
        e.preventDefault();
        showInlineError('Voer een geldig e-mailadres in.');
        if (input) input.focus();
        return;
      }
      if (consent && !consent.checked) {
        e.preventDefault();
        showInlineError('Vink het vakje aan om door te gaan.');
        return;
      }

      // Progressive enhancement: try a no-reload submit. If anything goes
      // wrong, fall back to a normal form post (full page reload).
      if (typeof fetch !== 'function' || typeof DOMParser !== 'function') return;

      e.preventDefault();
      setLoading(true);

      var formData = new FormData(form);
      fetch(form.action, { method: 'POST', body: formData, credentials: 'same-origin' })
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var freshRoot = doc.getElementById(root.id);
          if (!freshRoot) {
            form.submit();
            return;
          }
          var freshWrapper = freshRoot.querySelector('[data-newsletter-form-wrapper]');
          if (freshWrapper && wrapper) {
            wrapper.innerHTML = freshWrapper.innerHTML;
            var successEl = wrapper.querySelector('[data-newsletter-success]');
            var errorEl = wrapper.querySelector('[data-newsletter-error]');
            var focusTarget = successEl || errorEl;
            if (focusTarget) focusTarget.focus({ preventScroll: false });
            bindCopyButtons(wrapper);
          } else {
            form.submit();
          }
        })
        .catch(function () { form.submit(); })
        .finally(function () { setLoading(false); });
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-newsletter-section]').forEach(initNewsletterAdv);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
